export default __webpack_public_path__ + "static/media/htw4.229dc19c.svg";